import React, { useCallback, useContext, useRef, useState } from "react";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import { TabsContext } from "../../context/Tabs.context";
import { Panel, TabContainer, TabContent, TabHeader, TabIndicator, TabList } from "./Tabs.styled";

export const Tabs = ({ data, icon, styles }) => {
  const tabsRef = useRef([]);
  const nodeRef = useRef(null);
  const [direction, setDirection] = useState("forward");

  const { activeTab, setActiveTab } = useContext(TabsContext);

  const activeIndex = data.findIndex(({ key }) => key === activeTab);

  const setActiveTabWithDirection = useCallback(
    (newTab) => {
      const newIndex = data.findIndex(({ key }) => key === newTab);
      setDirection(newIndex > activeIndex ? "forward" : "backward");
      setActiveTab(newTab);
    },
    [activeIndex, data, setActiveTab]
  );

  const renderTab = (key, tab, isActive, index) => {
    return (
      <button
        key={key}
        role="tab"
        tabIndex={isActive ? 0 : -1}
        ref={(el) => (tabsRef.current[index] = el)}
        aria-selected={isActive}
        onClick={() => setActiveTabWithDirection(key)}
      >
        {tab}
      </button>
    );
  };

  const activePanel = data.find(({ key }) => key === activeTab);

  return (
    <TabContainer styles={styles}>
      <TabHeader>
        {icon && icon}
        <TabList role="tablist" icon={icon}>
          {data.map(({ key, tab }, index) => {
            const isActive = key === activeTab;
            return renderTab(key, tab, isActive, index);
          })}
          <TabIndicator tabCount={data.length} activeIndex={activeIndex} />
        </TabList>
      </TabHeader>
      <TabContent id="tab-content">
        <SwitchTransition>
          <CSSTransition
            classNames={`fade-${direction}`}
            timeout={200}
            key={activeTab}
            nodeRef={nodeRef}
            exit={false}
          >
            <Panel id="tab-panel" ref={nodeRef} role="tabpanel">
              {activePanel?.panel}
            </Panel>
          </CSSTransition>
        </SwitchTransition>
      </TabContent>
    </TabContainer>
  );
};
